__webpack_require__.p = "https://bmidxbhungaryplprod.netlify.app/";